<template>
  <div class="sb-textarea">
    <p class="title" v-if="title">{{ title }}</p>
    <div class="textarea-container">
      <textarea v-model="internalText" :maxlength="characterLimit" :style="{'min-height': minHeightStyle}" class="text-area"></textarea>
      <p v-if="characterLimit" class="textarea-info">({{ charAmount }}&nbsp;/&nbsp;{{ characterLimit }})</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SbTextArea',
  props: {
    characterLimit: {
      type: Number
    },
    placeholder: {
      type: String
    },
    title: {
      type: String
    },
    text: {
      type: String
    },
    minHeight: {}
  },
  computed: {
    minHeightStyle () {
      if (!this.minHeight) return
      else if (typeof this.minHeight === 'number') return this.minHeight + 'px'
      else return this.minHeight
    },
    internalText: {
      get () {
        return this.text
      },
      set (newText) {
        this.$emit('update:text', newText)
        this.$emit('updateText', newText)
      }
    },
    charAmount () {
      return this.text.length
    }
  },
  methods: {},
  i18n: {
    messages: {}
  }
}
</script>
<style scoped lang="scss">
.sb-textarea {
  p {
    font-weight: 600;
    margin: 0;
  }
  .textarea-container {
    display: flex;
    flex-direction: column;
    p {
      font-size: 14px;
      color: grey;
    }
  }
  textarea {
    flex-grow: 1;
    border-radius: 3px;
  }
}
</style>
